module.exports = __webpack_public_path__ + "static/media/19ESCAP28.ec373c16.jpg";